export const snackbarSelector = (state) => state.common.snackbar;

export const depositSelector = (state) => state.common.openDepositDialog;
